import React, { useEffect, useState } from 'react'
import './SecondaryCourseCard.scss'
import { TileContainer } from '@vds/tiles'
import { Body, Micro, Title } from '@vds/typography'
import { Icon } from '@vds/icons'
import { useTranslation } from 'react-i18next';
import {  getImageToBeRendered, navigateUsingLanguage } from '../../../../utility/utils';
import { ButtonIcon } from '@vds/button-icons';
import { isMobile, isTablet, isDesktop } from 'react-device-detect';
import { useSelector } from 'react-redux'

const SecondaryCourseCard = (props) => {
  const { t } = useTranslation();
  const { format, renditionType, courseId, desktopImage,sectionKey  } = props ?? {}
  const userLanguage = localStorage.getItem("lng")
  const screenType = isDesktop ? "desktop" : isTablet ? "tablet" : isMobile ? "mobile" : "desktop";
  const modifiedType = format === "Course" ? "courses" : format === "Event" ? "events" : format === "Learning Path" ? "learningpath" : "quickTips"
  const resourseId = modifiedType === "quickTips" ? courseId : courseId?.split(":")?.[1]; 
  // const defaultImageUrl = getImageToBeRendered(renditionType, screenType, modifiedType, userLanguage, resourseId, desktopImage);
  const [imageUrl, setImageUrl] = useState('');
  const imgFormat = useSelector((state) => state?.Aem?.imgFormat) ?? 'avif';

  useEffect(() => {
  // Helper to test if a URL is valid and reachable within 2 seconds
  const preloadImage = (url) => {
    return new Promise((resolve, reject) => {
      if (!url || url.trim() === "") return reject(new Error("Invalid URL"));
      const img = new Image();
      img.src = url;
      const timeout = setTimeout(() => {
        img.src = ""; // Stop the browser from continuing to load
        reject(new Error("Timeout"));
      }, 2000);
      
      img.onload = () => {
        clearTimeout(timeout);
        resolve(url);
      };
      img.onerror = () => {
        clearTimeout(timeout);
        reject(new Error("Image Load failed"));
      };
    });
  };

   let isCancelled = false;

   const loadImage = async () => {
    try {
      // 1.Call method with "avif" parameter
      try {
       const avifUrl = await getImageToBeRendered(renditionType, screenType, modifiedType, userLanguage, resourseId, desktopImage, imgFormat, sectionKey);
        await preloadImage(avifUrl);
        if (isCancelled) return;
        setImageUrl(avifUrl);
        return; 
      } catch (e) {
        console.warn("AVIF failed, trying PNG...");
      }

      // 2. Call method without "avif" (defaults to PNG)
      // try {
      //   const pngUrl = getImageToBeRendered(renditionType, screenType, modifiedType, userLanguage, resourseId, desktopImage);
      //   await preloadImage(pngUrl);
      //   setImageUrl(pngUrl);
      //   return; 
      // } catch (e) {
      //   console.warn("PNG failed, trying Fallback Data...");
      // }

      // 3. LMS image as fallback
      const dataFallbackUrl = desktopImage;
      if (dataFallbackUrl) {
        try {
          await preloadImage(dataFallbackUrl);
          if (isCancelled) return;
          setImageUrl(dataFallbackUrl);
          return;
        } catch (e) {
          console.warn("fallback image failed to load.");
        }
      }
    } catch (error) {
    
    }
  };

  loadImage();

  return () => {
    isCancelled = true;
  };
}, [renditionType, screenType, modifiedType, userLanguage, resourseId, desktopImage, imgFormat, sectionKey]);


  // useEffect(() => {
  //   const img = new Image();
  //   img.src = defaultImageUrl
  //   img.onload = () => {
  //     setImageUrl(defaultImageUrl)
  //   } 
    
  //   img.onerror = () => {
  //     setImageUrl(desktopImage);
  //   };
  // }, [props]);
  
  const getTimeInLanguage = (time) => {
    if(!time.includes('Event full')){
    time = time?.replace('minutes remaining', t('minutes remaining'));
    time = time?.replace('minutes', t('minutes'));
    time = time?.replace(/(\d+:\d+)\s?(am|pm)/gi, '$1 $2').replace(/(\d+):00\s?(am|pm)/gi, '$1 $2').replace(/-.*/, '');
    }
    return time;
  };

  const handleClick = (format) => {
    window.scrollTo(0, 0);
    localStorage.setItem("categoryPath",`category/${format}`)
    localStorage.setItem("courseUrl", window.location.href)
    if (format === "Learning Path") {
      navigateUsingLanguage(`/learning-details/${props?.courseId}`)
    } else {
      navigateUsingLanguage(`/course-details/${props?.courseId}`)
    }
  }

  return (
      <TileContainer
        tabIndex={-1}
        //ariaLabel={props.ariaLabel}
        padding="0"
        // aspectRatio="3:4"
        height='100%'
        width='100%'
        // showDropShadow={true}
        onClick={() => {handleClick (props?.format) }}
        backgroundColor="white"
      >
        <div className='secondary_course_card height-100'>
          <div className='image_icons width_fill_available'>
            {props?.tag && <span className="tag bg-white">
              <Body size="small" bold>{props.tag}</Body>
            </span>}
        </div>
        {<div className='image'>
          <img
            src={imageUrl}
            alt={props?.label} />
        </div>}
        <div className={`description pa-4X sm-pa-4X width-auto`}>
          <div className='label wrap_word mb-3X sm-mb-2X'>
            <div className={`n-displayFlex`} aria-label="Standard Course">
              <span>
                <Micro bold>{props?.formatLabel}</Micro>
              </span>
              {props?.resourceType && <span className='dot_wrap'></span>}
              {props?.format === "Quick Tip" ? <span><Micro>{props?.resourceType}</Micro></span> : <span><Micro>{props?.resourceType}</Micro></span>}
            </div>
          </div>
          <div className='title-label label mb-3X sm-mb-2X'>
            <Title ariaLabel={props?.label} size='medium'>{props?.label?.slice(0, 72)}</Title>
          </div>
          <div className='durations mt-auto width_fill_available'>
            <div className='textarea'>
              <div className='duration_text n-displayFlex' aria-label={props?.data?.dateAndTimeValue} style={{ color: '#716F6D' }}>
                {props?.duration?.preTextIcon && 
                <span className='mr-1X details_page_secondary_card_icon_container'>
                <Icon
                  name={props?.duration?.preTextIcon ? props?.duration?.preTextIcon : "calendar"}
                  size="small"
                  color={props?.data?.duration?.color}
                /></span>
                }
                {props?.duration?.preText && (<Micro
                  size="small"
                  color='#716F6D'
                  bold={true}
                  primitive="span">
                  <span className='mr-2X'> {t(props?.duration?.preText)}</span>
                </Micro>)}
                {props?.duration?.icon && props?.duration?.icon != "" && <span className='mr-1X details_page_secondary_card_icon_container'><Icon
                  name={props?.duration?.icon ? props?.duration?.icon : "timer"}
                  size="small"
                  color={props?.duration?.color}
                  /></span>}
                {props?.dateAndTimeValue && (<Micro
                  size="small"
                  color='#716F6D'
                  bold={true}
                  primitive="span">
                  <span className='mr-2X'>{t(getTimeInLanguage(props?.dateAndTimeValue))}</span>
                </Micro>)}
                <Micro
                  size="small"
                  color={props?.duration?.color}
                  bold={props?.duration?.preText ? false : true}
                  primitive="span">
                  {props?.format === "Quick Tip" ? <span className="ml-2X">{getTimeInLanguage(props?.duration?.time)}</span> : <span className="">{t(getTimeInLanguage(props?.duration?.time))}</span>}
                </Micro>
              </div>
              <div>
                <ButtonIcon
                  role="link"
                  tabIndex={0}
                  className="course-arrow-firefox"
                  ariaLabel={`${props?.ariaLabel ? props?.ariaLabel?.replace('undefined', '') : ""} ${props?.label} ${t(props?.format)}`}
                  kind="ghost"
                  size="large"
                  renderIcon={(props) => <Icon name="right-arrow" {...props} size="large"/>}
                  onClick={(e) => handleClick(props?.format)}
                />
              </div>
            </div>
          </div>
        </div>
      </div>
    </TileContainer>
  )
}

export default SecondaryCourseCard